import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../../_models/ITranslations";
import { FamilyModel } from "../../../brothers-attribution/brother-attribution-models/family-model";
import { TranslationService } from "../../../../_services/translation.service";
import { SessionManagerService } from "../../../../_services/SessionManager/session-manager.service";
import { GenericModalComponent } from "../../../../form/generic-app-modal/generic-modal.component";
import { DataService } from "../../../../_services/data.service";
import { AuthenticationService } from "../../../../_services/authentication.service";

@Component({
  selector: "upload-excel-file-interface",
  templateUrl: "./upload-excel-file-interface.component.html",
  styleUrls: ["./upload-excel-file-interface.component.scss"],
})
export class UploadExcelFileInterfaceComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();

  public disableSave: boolean = true;

  public translations$: Observable<ITranslations>;
  private familyStatus: FamilyModel[];

  constructor(
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {}

  public saveChanges(number: number) {
    this.modalNotification("25 משתמשים נוספו בהצלחה!").then();
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  public updateFamilyStatus($event: FamilyModel[]) {
    this.familyStatus = $event;
    this.disableSave = this.familyStatus.length <= 1;
  }

  public onFileChange($event: Event) {
    // @ts-ignore
    if ($event.target.value) {
      this.disableSave = false;
    }
  }

  protected async modalNotification(message: string) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "הוספת משתמשים",
      modalText,
      onlyApprove: true,
    };
    await modalRef.result;
    await this.closeParentEventModal();
  }

  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך  `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-upload-users-excel-modal/upload-excel-file-interface/upload-excel-file-interface.component.ts